import React from 'react';
import PropTypes from 'prop-types';
import {useMemo, useReducer, useCallback, useEffect} from 'react';

import {MainContext} from './main-context';
import axios from 'axios';
import config from '../../helper/config';
import APIHandler from '../../handlers/APIHandler';

const initialState = {
  loading: false,
  loadingNode:false,
  formLoading: false,
  highlightCard:null,
  node_array:[], // hierarchyGridBottomData
  form_array:[],
  nodes_data:[],
  selected_node_array:[],
  hierarchy_node_add_state:null,
  selected_form:null,
  last_mid:null,
  last_fmid:null,
  last_formid:null,
  authorize_code_graph_api:null
};

const reducer = (state, action) => {
  if (action.type === 'INITIAL') {
    return {
      loading: action.payload.loading,
      loadingNode: action.payload.loadingNode,
      formLoading:action.payload.formLoading,
      highlightCard: action.payload.highlightCard,
      node_array: action.payload.node_array, // hierarchyGridBottomData
      form_array:action.payload.form_array,
      nodes_data:action.payload.nodes_data,
      selected_node_array: action.payload.selected_node_array,
      hierarchy_node_add_state: action.payload.hierarchy_node_add_state,
      selected_form: action.payload.selected_form,
      last_mid: action.payload.last_mid,
      last_fmid: action.payload.last_fmid,
      last_formid: action.payload.last_formid,
      authorize_code_graph_api: action.payload.authorize_code_graph_api,

    };
  }
  if (action.type === 'SET_ALL_NODE_LIST') {
    return {
      ...state,
      node_array: action.payload.node_array, // hierarchyGridBottomData
    };
  }
  if (action.type === 'GET_ALL_NODE_LIST') {
    return {
      ...state,
      node_array: action.payload.node_array, // hierarchyGridBottomData
      nodes_data: action.payload.nodes_data,
    };
  }
  if (action.type === 'UPDATE_ALL_NODE_LIST') {
    return {
      ...state,
      node_array: action.payload.node_array, // hierarchyGridBottomData
    };
  }
  if (action.type === 'GET_ALL_FORM_LIST') {
    return {
      ...state,
      form_array: action.payload.form_array,
    };
  }
  if (action.type === 'SET_ALL_FORM_LIST') {
    return {
      ...state,
      form_array: action.payload.form_array,
    };
  }
  if (action.type === 'SET_LOADING_NODE_STATE') {
    return {
      ...state,
      loadingNode: action.payload.loadingNode,
    };
  }
  if (action.type === 'SET_FORM_LOADING_STATE') {
    return {
      ...state,
      formLoading: action.payload.formLoading,
    };
  }
  if (action.type === 'SET_HIGHLIGHTED_CARD') {
    return {
      ...state,
      highlightCard: action.payload.highlightCard,
    };
  }
  if (action.type === 'SET_SELECTED_FORM') {
    return {
      ...state,
      selected_form: action.payload.selected_form,
    };
  }
  if (action.type === 'GET_SELECTED_NODE_LEVEL_NODE_LIST') {
    return {
      ...state,
      selected_node_level_node_array: action.payload.selected_node_level_node_array,
    };
  }
  if (action.type === 'INSERT_HIERARCHY_NODE') {
    return {
      ...state,
      hierarchy_node_add_state: action.payload.hierarchy_node_add_state,
    };
  }
  if (action.type === 'SET_INSERT_HIERARCHY_NODE_STATE') {
    return {
      ...state,
      hierarchy_node_add_state: action.payload.hierarchy_node_add_state,
    };
  }
  if (action.type === 'SET_LAST_MID') {
    
    return {
      ...state,
      last_mid: action.payload.last_mid,
    };
  }
  if (action.type === 'SET_LAST_FMID') {
    
    return {
      ...state,
      last_fmid: action.payload.last_fmid,
    };
  }
  if (action.type === 'SET_LAST_FORMID') {
    
    return {
      ...state,
      last_formid: action.payload.last_formid,
    };
  }
  if (action.type = "SET_AUTH_CODE_GRAPH_API"){

    return{
      ...state,
      authorize_code_graph_api: action.payload.authorize_code_graph_api,
    }
  }
  
  return state;
};

// ----------------------------------------------------------------------

export function MainContextProvider({children}) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const initialize = useCallback(async () => {
    
    dispatch({
      type: 'INITIAL',
      payload: {
        loading: false,
        loadingNode:false,
        formLoading: false,
        highlightCard:null,
        node_array:[],
        form_array:[],
        nodes_data:[],
        selected_node_array:[],
        hierarchy_node_add_state:null,
        selected_form:null,
        last_mid: null,
        last_fmid: null,
        last_formid: null,
        authorize_code_graph_api: null,
      },
    });

  }, []);
 
  useEffect(() => {
    initialize();
  }, [initialize]);

  const set_loading_node_state = useCallback(async (value) => {

    dispatch({
      type: 'SET_LOADING_NODE_STATE',
      payload: {
        loadingNode: value ? value:false
      },
    });

  }, []);

  const set_form_loading_state = useCallback(async (value) => {

    dispatch({
      type: 'SET_FORM_LOADING_STATE',
      payload: {
        formLoading: value ? value:false
      },
    });

  }, []);

  const set_highlighted_card = useCallback(async (value) => {

    dispatch({
      type: 'SET_HIGHLIGHTED_CARD',
      payload: {
        highlightCard: value ? value:null
      },
    });

  }, []);

  const set_selected_form = useCallback(async (value) => {

    dispatch({
      type: 'SET_SELECTED_FORM',
      payload: {
        selected_form: value ? value:null
      },
    });

  }, []);

  const get_all_node_array = useCallback(async (child_id, exclude_code, user_id, user_table_id) => {

    const requestOptions = {
      headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await axios.get(`${config.oat_api_url}/manage/tree-main-hierarchy-nodes/get-nodes-info/${child_id}/${exclude_code}/${user_id}/${user_table_id}`,requestOptions);

    const { success, message, data } = response.data    

      dispatch({
        type: 'GET_ALL_NODE_LIST',
        payload: {
          node_array: {
            success,
            message,
            data,
          },
          nodes_data:{
            data,
          }
        },
      });

  }, []);
  
  const get_all_forms = useCallback(async (node_mid, node_hide_id, user_id, user_table_id) => {

    const requestOptions = {
      headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await axios.get(`${config.oat_api_url}/manage/tree-main-hierarchy-nodes/get-all-forms/${node_mid}/${node_hide_id}/${user_id}/${user_table_id}`,requestOptions);
    
    const { success, message, data } = response.data

    
    
    dispatch({
      type: 'GET_ALL_FORM_LIST',
      payload: {
        form_array: {
          data,
          success,
          message
        },
      },
    });
  }, []);

  const set_node_array = useCallback(async (node_array) => {

    dispatch({
      type: 'SET_ALL_NODE_LIST',
      payload: {
        node_array: node_array
      },
    });

  }, []);

  const set_form_array = useCallback(async (form_array) => {

    dispatch({
      type: 'SET_ALL_FORM_LIST',
      payload: {
        form_array: form_array
      },
    });

  }, []);

  const get_selcted_node_level_node_array = useCallback(async (child_id, exclude_code, user_id, user_table_id) => {

    const requestOptions = {
      headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await axios.get(`${config.oat_api_url}/manage/tree-main-hierarchy-nodes/get-grand-child-node-list/${child_id}/${exclude_code}/${user_id}/${user_table_id}`,requestOptions);

    const { success, message, data } = response.data    

      dispatch({
        type: 'GET_SELECTED_NODE_LEVEL_NODE_LIST',
        payload: {
          selected_node_level_node_array: {
            success,
            message,
            data,
          },
        },
      });

  }, []);

  const insert_hierarchy_node = useCallback(async (child) => {

    const requestOptions = {
      headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await axios.post(`${config.oat_api_url}/manage/tree-main-hierarchy-nodes/add`,JSON.stringify(child),requestOptions);

    const { success, message, data } = response.data    

      dispatch({
        type: 'INSERT_HIERARCHY_NODE',
        payload: {
          hierarchy_node_add_state: {
            success,
            message,
            data,
          },
        },
      });

  }, []);

  const set_hierarchy_node_add_state = useCallback(async (value) => {

    dispatch({
      type: 'SET_INSERT_HIERARCHY_NODE_STATE',
      payload: {
        hierarchy_node_add_state: null
      },
    });

  }, []);

  const set_last_mid = useCallback(async (last_mid) => {

    dispatch({
      type: 'SET_LAST_MID',
      payload: {
        last_mid: last_mid
      },
    });

  }, []);

  const set_last_fmid = useCallback(async (last_fmid) => {

    dispatch({
      type: 'SET_LAST_FMID',
      payload: {
        last_fmid: last_fmid
      },
    });

  }, []);

  const set_last_formid = useCallback(async (last_formid) => {

    dispatch({
      type: 'SET_LAST_FORMID',
      payload: {
        last_formid: last_formid
      },
    });

  }, []);

  const set_auth_code_graph_api = useCallback(async (authorize_code_graph_api) => {

    dispatch({
      type: 'SET_AUTH_CODE_GRAPH_API',
      payload: {
        authorize_code_graph_api: authorize_code_graph_api
      },
    });

  }, []);


  // ----------------------------------------------------------------------


  const memoizedValue = useMemo(
    () => ({
      loading: state.loading,
      loadingNode: state.loadingNode,
      formLoading: state.formLoading,
      node_array: state.node_array, // hierarchyGridBottomData
      form_array: state.form_array,
      nodes_data: state.nodes_data,
      highlightCard: state.highlightCard,
      selected_node_level_node_array: state.selected_node_level_node_array,
      hierarchy_node_add_state: state.hierarchy_node_add_state,
      selected_form: state.selected_form,
      last_mid: state.last_mid,
      last_fmid: state.last_fmid,
      last_formid: state.last_formid,
      authorize_code_graph_api: state.authorize_code_graph_api,

      set_loading_node_state,
      set_form_loading_state,
      set_highlighted_card,
      get_all_node_array,
      set_node_array,
      set_form_array,
      get_all_forms,
      get_selcted_node_level_node_array,
      insert_hierarchy_node,
      set_hierarchy_node_add_state,
      set_selected_form,
      set_last_mid,
      set_last_fmid,
      set_last_formid,
      set_auth_code_graph_api,
    
    }), [
        set_loading_node_state,
        set_form_loading_state,
        set_highlighted_card,
        get_all_node_array,
        set_node_array,
        set_form_array,
        get_all_forms,
        get_selcted_node_level_node_array,
        insert_hierarchy_node,
        set_hierarchy_node_add_state,
        set_selected_form,
        set_last_mid,
        set_last_fmid,
        set_last_formid,
        set_auth_code_graph_api,

        state
      ]);

  return <MainContext.Provider value={memoizedValue}>{children}</MainContext.Provider>;
}

MainContextProvider.propTypes = {
  children: PropTypes.node,
};
